<template>
    <a-col :span="24" class="setting-content">
        <long-tail-list />
    </a-col>
</template>

<script>

import LongTailList from '@/com/Longtail/LongTailList.vue'

export default 
{
    name: 'lontailsetting',

    data() 
    {
      return {
          tab: 'uc,ltls',
      }
    },

    components: 
    {
        LongTailList
    },

    created() 
    {
        this.$store.commit('changetab', this.tab)
    }
}
</script>

<style scoped>

    .setting-content 
    {
        padding: 8px 0px 8px 0px;
    }
    
</style>
